import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, from } from "@apollo/client";

const isBrowser = typeof window !== 'undefined';
let client = {};

if (isBrowser) {
    const httpLink = new HttpLink({
        uri: `${process.env.GATSBY_COSTOS_ACCOUNTS_API}/graphql`,
    });

    const authLink = new ApolloLink(async (operation, forward) => {
        const { getAccessTokenSilently } = operation.getContext();

        if (typeof getAccessTokenSilently === "function") {
            let token;
            try {
                token = await getAccessTokenSilently();
            } catch (e) {
                console.log("error getting access token", e);
            }

            // add the authorization to the headers
            operation.setContext(({ headers = {} }) => ({
                headers: {
                    ...headers,
                    authorization: token ? `Bearer ${token}` : "",
                }
            }));
        }

        return forward(operation);
    });

    client = new ApolloClient({
        link: process.env.GATSBY_ACTIVE_ENV === "development"
            ? httpLink
            : from([authLink, httpLink]),
        cache: new InMemoryCache(),
    });
}

export const apolloClient = client;
